<template>
  <div>
    <div class="order-status" v-if="order_type === CONST.ORDER_TYPE_ONLINE">
      <StatusCard></StatusCard>
      <DriverInfo
        v-if="order_status.order_system_status !== 'rejected'"
      ></DriverInfo>
    </div>
    <div class="order-status" v-else>
      <h4 class="order-status-takeaway">
        {{
          _T(
            'Your order has been placed successfully, you can collect it after'
          )
        }}
        <span v-html="deliveryTime"></span>.
      </h4>
    </div>
    <ShippingDetail></ShippingDetail>
  </div>
</template>

<script>
import StatusCard from './StatusCard'
import DriverInfo from './DriverInfo'
import ShippingDetail from './ShippingDetail'
import Delivery from '@/mixins/Delivery'

import { mapState } from 'vuex'
export default {
  mixins: [Delivery],
  components: {
    StatusCard,
    DriverInfo,
    ShippingDetail,
  },
  computed: {
    ...mapState({
      order_status: state => state.tracking_store.order_status,
    }),
  },
}
</script>

<style lang="scss" scoped>
.order-status-takeaway {
  color: green;
  font-weight: bold;
}
.order-status {
  padding: calc(#{$px20} + (32 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
  border-bottom: $px2 solid $light-border;
}
</style>
